export const MARKETPLACE_STATUS = {
  DRAFT: "DRAFT", SUBMITTED: "SUBMITTED", UNDER_REVIEW: "UNDER_REVIEW",
  CLARIFICATION_REQUIRED: "CLARIFICATION_REQUIRED", AVAILABILITY_VERIFIED: "AVAILABILITY_VERIFIED",
  REJECTED: "REJECTED", APPROVED_FOR_NEGOTIATION: "APPROVED_FOR_NEGOTIATION",
  NEGOTIATION_IN_PROGRESS: "NEGOTIATION_IN_PROGRESS", RATE_AGREED: "RATE_AGREED",
  PENDING_FINAL_APPROVAL: "PENDING_FINAL_APPROVAL", PURCHASE_APPROVED: "PURCHASE_APPROVED",
  PURCHASE_REJECTED: "PURCHASE_REJECTED", PURCHASE_ORDER_CREATED: "PURCHASE_ORDER_CREATED",
  AWAITING_RECEIPT: "AWAITING_RECEIPT", PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
  RECEIVED: "RECEIVED", QUALITY_REJECTED: "QUALITY_REJECTED", STOCK_POSTED: "STOCK_POSTED",
  COMPLETED: "COMPLETED", CANCELLED: "CANCELLED",
};

export const WORKFLOW_STEPS = ["Submitted", "Under Review", "Verified", "Negotiation", "Approved", "Purchase Order", "Received", "Quality Checked", "Stock Posted", "Completed"];
